var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#21752B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7947 10.5363H12.448L12.9798 8.16558C13.0587 7.87269 13.0015 7.5598 12.824 7.31388C12.6465 7.06785 12.3676 6.91488 12.0647 6.89746C11.7424 6.90208 11.4457 7.0744 11.282 7.35218L9.32248 10.5363H8.75904C8.63626 10.5363 8.5185 10.585 8.43171 10.6718C8.34492 10.7587 8.29614 10.8764 8.29614 10.9993V16.6393C8.29614 16.7621 8.34492 16.8799 8.43171 16.9668C8.5185 17.0535 8.63627 17.1023 8.75904 17.1023H15.8344C15.9605 17.0985 16.0816 17.0516 16.1775 16.9696C16.2734 16.8877 16.3385 16.7754 16.3621 16.6515L17.5099 11.5323V11.5322C17.5724 11.3028 17.5281 11.0573 17.3894 10.864C17.2506 10.6708 17.0322 10.5504 16.7947 10.5361L16.7947 10.5363Z",
    fill: "#21752B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9254 10.5386H7.26851C7.52416 10.5386 7.73151 10.7942 7.73151 11.0016V16.6396C7.73151 16.8953 7.52426 17.1026 7.26851 17.1026H6.9254C6.66975 17.1026 6.4624 16.847 6.4624 16.6396V11.0016C6.4624 10.7459 6.66965 10.5386 6.9254 10.5386Z",
    fill: "#21752B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4b29dab03259560485ae4653d3bc0e02.svg";
export { ForwardRef as ReactComponent };